import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart, Trash2 } from "lucide-react";
import { getFavorites, removeFavorite, onFavoritesChange } from "../lib/favorites";

const ratingColor = (r) => (r === "red" ? "#FF3B3B" : r === "yellow" ? "#FFB800" : "#00C853");

export default function Favorites() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    setItems(getFavorites());
    const off = onFavoritesChange(setItems);
    return off;
  }, []);

  return (
    <div data-testid="favorites-page" className="max-w-5xl mx-auto px-6 md:px-10 py-12 md:py-16">
      <div className="mb-8">
        <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-[color:var(--text-3)] mb-2">
          Your Pantry
        </div>
        <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tighter">
          Saved <span className="text-[color:var(--lime)]">products</span>
        </h1>
        <p className="mt-3 text-[color:var(--text-2)]">
          Stored locally on this device. No account, no sync — just your personal shelf.
        </p>
      </div>

      {items.length === 0 ? (
        <div data-testid="favorites-empty" className="surface rounded-xl p-10 text-center">
          <Heart className="h-10 w-10 mx-auto text-[color:var(--text-3)] mb-3" strokeWidth={1.5} />
          <div className="font-display text-xl mb-2">No saved products yet</div>
          <p className="text-sm text-[color:var(--text-2)] mb-6">
            Tap the heart icon on any product page to pin it here.
          </p>
          <Link to="/" className="lime-btn inline-block rounded-lg px-4 py-2 text-sm" data-testid="favorites-browse">
            Browse products
          </Link>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="favorites-list">
          {items.map((f, i) => {
            const color = ratingColor(f.overallRating);
            return (
              <div key={f.slug} className="surface rounded-xl p-4 flex items-start justify-between gap-3" data-testid={`favorite-${i}`}>
                <Link to={`/product/${f.slug}`} className="min-w-0 flex-1">
                  <div className="font-display font-semibold truncate">{f.productName}</div>
                  <div className="text-xs text-[color:var(--text-3)] truncate">{f.brand || "—"}</div>
                  <div className="mt-2 font-mono text-2xl font-bold" style={{ color }}>
                    {f.overallScore ?? "—"}
                    <span className="text-[10px] text-[color:var(--text-3)] ml-1">/100</span>
                  </div>
                </Link>
                <button
                  onClick={() => removeFavorite(f.slug)}
                  className="ghost-btn rounded-md p-2 text-[color:var(--text-3)] hover:text-[color:var(--danger)]"
                  aria-label="Remove"
                  data-testid={`favorite-remove-${i}`}
                >
                  <Trash2 className="h-4 w-4" />
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
